import { useEffect } from "react";
import { useUrlContext } from "../UrlProvider";
import { defaultSortOptions } from "../../../../savedItemsSortConfig";

export const useSortSearchParam = ({ changeSort, displayValue }) => {
  const { setSearchParams } = useUrlContext();

  const setValue = ({
    nativeEvent: {
      target: { value: sort }
    }
  }) => {
    changeSort({ sort });
  };

  useEffect(() => {
    const sort =
      displayValue === defaultSortOptions.value ? null : displayValue;
    setSearchParams({ sort });
  }, [displayValue]);

  return { setValue };
};
